import { Upload, message, Image } from "antd";
import { UploadIcon } from "../../../../../../../atoms/CustomIcons";
import React, { useState } from "react";

const { Dragger } = Upload;

interface FileType {
  name: string;
  type: string;
  size: number;
}

interface PropsType {
  setChecklistFile: React.Dispatch<React.SetStateAction<FileType | null>>;
  checklistFile: FileType | null;
}

export default function FileDragger(props: PropsType) {
  const { setChecklistFile, checklistFile } = props;

  const [fileSize, setFileSize] = useState("");

  // const defaultProps: UploadProps = {
  //   name: "file",
  //   multiple: true,
  //   action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  //   onChange(info) {
  //     const { status } = info.file;
  //     if (status === "done") {
  //       message.success(`${info.file.name} file uploaded successfully.`);
  //     } else if (status === "error") {
  //       message.error(`${info.file.name} file upload failed.`);
  //     }
  //   },
  //   onDrop(e) {
  //     console.log("Dropped files", e.dataTransfer.files);
  //   },
  // };

  const formatBytes = (bytes: number) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleFileChange = (
    e: FileType
  ): boolean | typeof Upload.LIST_IGNORE => {
    setChecklistFile(e);
    console.log(e);
    if (e) {
      const formattedSize = formatBytes(e?.size);
      setFileSize(formattedSize);
    } else {
      setFileSize("");
    }

    const isPDF = e.type === "text/csv";
    if (!isPDF) {
      message.error(`${e.name} is not a csv file`);
    }
    return isPDF || Upload.LIST_IGNORE;
  };

  return (
    // <Dragger {...defaultProps} {...props}>
    //   <p className="ant-upload-drag-icon">
    //     <UploadIcon />
    //   </p>
    //   <p className="ant-upload-text">
    //     Drag & drop or <span>browse</span> to choose a file
    //   </p>
    //   <p className="ant-upload-hint">The file size should be less than 5 MB.</p>
    // </Dragger>

    <Dragger
      showUploadList={false}
      fileList={[]}
      name="file"
      beforeUpload={handleFileChange}
      customRequest={() => null}
      maxCount={1}
      accept=".csv"
    >
      {checklistFile?.name ? (
        <>
          <p
            className="ant-upload-drag-icon"
            style={{ marginBottom: 8, height: 24 }}
          >
            <Image src="/images/upload-icon.svg" preview={false} width={24} />
          </p>
          <p className="ant-upload-text" style={{ marginBottom: 6 }}>
            {checklistFile?.name}
          </p>
          {fileSize && (
            <p className="ant-upload-hint" style={{ margin: 0 }}>
              {fileSize}
            </p>
          )}
        </>
      ) : (
        <>
          <p className="ant-upload-drag-icon">
            <UploadIcon />
          </p>
          <p className="ant-upload-text">
            Drag & drop or <span>browse</span> to choose a file
          </p>
          <p className="ant-upload-hint">
            The file size should be less than 5 MB.
          </p>
        </>
      )}
    </Dragger>
  );
}
